import * as React from 'react'

import Svg, { G, Path, Defs, ClipPath } from 'react-native-svg'

import { IconProps } from '../icons'

const CallCancelOutlined = ({
  size = 24,
  color = '#000',
  ...props
}: IconProps) => (
  <Svg
    width={`${size}px`}
    height={`${size}px`}
    viewBox="0 0 24 24"
    fill={color}
    {...props}
  >
    <G clipPath="url(#a)" fill={color}>
      <Path d="M8.63 14.14c-2.01-2.45-2.9-4.66-2.61-6.57.24-1.56 1.18-2.4 1.62-2.72l.5-.44c.1-.09.24-.18.35-.18h.02c.13.02.41.17.92.96l.41.64c.83 1.29.56 1.69.22 1.99l-.56.49s-.07.05-.11.07c-.29.2-.91.61-1.02 1.45-.11.86.32 1.88 1.37 3.19l1.01-1.01c-.94-1.22-1-1.79-.97-2 .03-.19.15-.29.4-.46.1-.06.18-.12.24-.18l.57-.49c1.59-1.39.42-3.21.04-3.81l-.41-.64c-.44-.68-1.05-1.47-1.91-1.6-.52-.07-1.02.1-1.5.52l-.46.4c-.54.39-1.82 1.53-2.14 3.62-.35 2.34.67 4.96 3.01 7.78l1-1 .01-.01ZM19.34 14.46l-.57-.49c-.54-.46-2.19-1.87-3.79-.49l-.56.49c-.06.05-.13.13-.21.22-.2.23-.32.33-.51.33-.17 0-.58-.1-1.3-.72l5.89-5.89c.3-.3.3-.79 0-1.09-.3-.3-.79-.3-1.09 0L5.15 18.85a.773.773 0 0 0 .55 1.32c.2 0 .4-.08.55-.23l3.03-3.03c2.12 2.03 4.22 3.08 6.26 3.08h.07c2.11-.02 3.41-1.14 3.83-1.57l.51-.44c.48-.42.72-.89.72-1.41 0-.88-.71-1.59-1.32-2.12l-.01.01Zm-.33 2.46-.55.49c-.34.35-1.3 1.17-2.88 1.18-1.68-.02-3.46-.9-5.32-2.67l1.13-1.13c.86.76 1.6 1.13 2.29 1.14.83-.02 1.34-.54 1.57-.8.03-.04.06-.07.09-.1l.56-.49c.34-.3.77-.5 1.94.5l.57.49c.75.64.83.95.83 1.05 0 .12-.13.25-.23.34Z" />
    </G>
    <Defs>
      <ClipPath id="a">
        <Path fill="#fff" d="M0 0h24v24H0z" />
      </ClipPath>
    </Defs>
  </Svg>
)

export default CallCancelOutlined
